module.exports = __webpack_public_path__ + "static/media/_pipe.5209e2db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_pipe.jpg
// module id = 67
// module chunks = 0